import { axiosClient } from 'www/utils'
import type {
  ApiDiseaseParamsGet,
  ApiDiseaseResponseGet,
} from 'www/vue_components/common/TheFilters/doctors/api/apiDiseases.types'

export default {
  get(params: ApiDiseaseParamsGet) {
    return axiosClient.get<ApiDiseaseResponseGet>('/api/diseases-by-speciality/', { params })
  },
}
